function uniqueID(length = 10) {
    return `_${ Math.random().toString(36).substr(2, length) }`;
}

export { uniqueID };
